import { articelsHomePageImages } from '../../../services/images.service'
import { ArticleTag } from '../../HomePage/ArticleTag'
import { Link } from 'react-router-dom'
import { useAuthorMap } from '../../../hooks/useAuthorMap'
import { useSelector } from 'react-redux'
import { PostDetailsHeader } from './PostDetailsHeader'
import { Button, GreyDivider } from '../../ui/elements'

export const PostDetailsMobileTop = ({
  selectedPost,
  setIsEditing,
  handleRemovePost,
  loggedInUser,
}) => {
  const authorMap = useAuthorMap()
  const author = authorMap[selectedPost?.author?.userId]

  if (!author) return null

  const postCount = author?.postCount ?? 0


  return (
    <div className="lg:hidden">
      <PostDetailsHeader post={selectedPost} />
      <div className='p-4'>
        <div className="relative mt-10">
          <div className="relative">
            <GreyDivider />
            <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <ArticleTag tags={selectedPost.tags} />
            </div>
          </div>
        </div>

        <div className="flex items-center justify-between mt-6">
          <div className="flex gap-2 items-center">
            <img
              className="w-16 h-16 rounded-full"
              src={author.image}
              alt="Author img"
            />
            <div>
              <Link to={`/user/${author.username}`}>
                <h3 className="text-lg font-semibold">{author.nickname}</h3>
              </Link>
              <p className="text-sm">{postCount} כתבות</p>
            </div>
          </div>
          <img
            src="https://res.cloudinary.com/drejchdwh/image/upload/v1732629076/unselected-watchlist_vg0jty.svg"
            alt="Add to favorites"
          />
        </div>
      </div>

      {loggedInUser &&
        (loggedInUser.role === 'admin' || loggedInUser.role === 'editor') && (
          <div className="flex justify-center gap-4 mt-4">
            <Button
              text="ערוך כתבה"
              width={240}
              height={60}
              onClick={() => setIsEditing(true)}
              fontSize="text-lg"
              textColor="text-buttonSecondary1"
              bgColor="fill-accentLight"
              hoverBgColor="hover:scale-105 transform duration-300"
              aria-label="ערוך את הכתבה הנוכחית"
              title="ערוך כתבה"
            />

            <Button
              text="הסר כתבה"
              width={240}
              height={60}
              onClick={async () => {
                handleRemovePost(selectedPost._id)
              }}
              fontSize="text-lg"
              textColor="text-buttonSecondary1"
              bgColor="fill-accentLight"
              hoverBgColor="hover:scale-105 transform duration-300"
              aria-label="מחק את הכתבה הנוכחית"
              title="הסר כתבה"
            />
          </div>
        )}
    </div>
  )
}
